function calculateSalary() {
    let ageInput = document.getElementById('age');
    let hoursInput = document.getElementById('hours');

    //Continue if age and hours input are filled correctly
    if (ageInput.validity.valid == true && hoursInput.validity.valid == true) {
        let findAge = getSalaryByAge(ageInput.value);
        let findSalary = findAge[0].salary;
        let weekSalary = findSalary * hoursInput.value;

        document.querySelector('#salary-calculator p').classList.remove('hide');
        document.querySelector('#salary-calculator a').classList.remove('hide');
        document.getElementById('salary').innerText = '€ ' + weekSalary.toFixed(2);
    }
}

document.querySelector('#salary-calculator button').addEventListener('click', calculateSalary);

//Loop through salaries object and find correct salary by age
function getSalaryByAge(age) {
    return salaries.filter(
        function (data) {
            if (age > 21) {
                age = 21;
            }
            return data.age == age
        }
    );
}
